module.exports = __webpack_public_path__ + "static/profil-513_optimized-c41b122bec72b9a820d47f489f13c986.jpg";